import { render, staticRenderFns } from "./AcademicQualifications.vue?vue&type=template&id=419351c4&scoped=true"
import script from "./AcademicQualifications.vue?vue&type=script&lang=js"
export * from "./AcademicQualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419351c4",
  null
  
)

export default component.exports